module.exports = __webpack_public_path__ + "img/Pista_3012.f1deb308.png";